module.exports = __webpack_public_path__ + "img/SEJ enventos_registro de eventos.e85d1b91.svg";